"use strict";
exports.__esModule = true;
exports.isProvider = exports.ProviderId = void 0;
/**
 * @enum ProviderId
 * @description Defines the providers configured in integrations gateway
 */
var ProviderId;
(function (ProviderId) {
    ProviderId["morningstar"] = "morningstar";
    ProviderId["nscc"] = "nscc";
    ProviderId["bloomberg"] = "bloomberg";
})(ProviderId = exports.ProviderId || (exports.ProviderId = {}));
var isProvider = function (source) {
    return !!ProviderId[source];
};
exports.isProvider = isProvider;
